import React, { Component } from 'react'
import Link from 'gatsby-link'

import './title.css'

class Title extends Component {

  render () { 
    let name = this.props.name;

    return (
      <div className = "title">
        {name}
      </div>
    );
  }
}


export default {Title}



// WEBPACK FOOTER //
// ./src/components/Title/index.js